import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	selector: 'wd-error-list-modal',
	template: `
		<div class="modal-header">
			<h5 class="modal-title">{{ title }}</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<div class="error-container">
				@for (error of errors; track error) {
					<div class="error-item">{{ error }}</div>
				}
				@if (errors.length === 0) {
					<div class="no-errors">Keine Fehler</div>
				}
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="copyToClipboard()">
				<i class="bi bi-clipboard"></i> Kopieren
			</button>
			<button type="button" class="btn btn-primary" (click)="activeModal.close(true)">OK</button>
		</div>
	`,
	styles: [`
		.error-container {
			max-height: 400px;
			overflow: auto;
			font-family: monospace;
			font-size: 0.85rem;
			background: #f8f9fa;
			border: 1px solid #dee2e6;
			border-radius: 4px;
			padding: 0.5rem;
		}
		.error-item {
			padding: 0.5rem;
			border-bottom: 1px solid #dee2e6;
			white-space: pre-wrap;
			word-break: break-all;
		}
		.error-item:last-child {
			border-bottom: none;
		}
		.no-errors {
			padding: 1rem;
			text-align: center;
			color: #6c757d;
		}
	`],
})
export class ErrorListModalComponent {
	@Input() title = 'Fehler';
	@Input() errors: string[] = [];

	constructor(public activeModal: NgbActiveModal) {}

	copyToClipboard(): void {
		const text = this.errors.join('\n\n');
		navigator.clipboard.writeText(text);
	}
}
